import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    contactList: () => {
        return HTTP.get('/cotact_current/1', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editContact: (id,data) => {
        return HTTP.post(`/cotact_update/${id}`,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}